/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_TaglineInputs */



/**
* | output |
* | --- |
* | "VEKN Tournament Management" |
*
* @param {Common_TaglineInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const common_tagline = /** @type {((inputs?: Common_TaglineInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_TaglineInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gestion des tournois VEKN")
	if (locale === "es") return /** @type {LocalizedString} */ ("Gestión de Torneos VEKN")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Gerenciamento de Torneios VEKN")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gestione Tornei VEKN")
	return /** @type {LocalizedString} */ ("VEKN Tournament Management")
});